import React, { Component } from 'react';
import {connect} from 'react-redux';
import { ModalState, selectMenuItem, itemsFetchData} from '../actions/actions';
import {bindActionCreators} from 'redux';
import { IMAGE } from '../constants'


class PicadaRow extends Component {

  constructor(props) {
    super(props);
    this.state = {picadas: []}
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.items !== this.props.items){
      this.setState(
        {
          picadas: nextProps.items
        }
      )
    }
  }


  PicadaGroup() {
    return this.state.picadas.map((e, i) => {
      return(
        <div className='picadaBox'
          onClick={()=> {this.props.selectMenuItem(e); this.props.ModalState(true);}}   
          key={i}>
          <div className="thumbnail">
            <img className="img" src={require(`../img${IMAGE[e.id]}`)} alt="..." key={IMAGE[e.id]} />
            <div className="caption">
              <h3>{e.nom}</h3>
              <div className="precioContainer">
                <div>Chica <span>${e.pre}</span></div>
                <div>Grande <span>${e.pre2}</span></div>
              </div>
            </div>
          </div>
        </div>
       )
    })
  }
  render(){
    
    return(
      <div className="picadaContainer" id="picadas">
        {this.props.hasErrored &&
            <p>Sorry! There was an error loading the items</p>
        }
        {this.props.isLoading &&
          <div>Cargando</div>
        }
        {this.props.items &&
          this.PicadaGroup()
        }
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    hasErrored: state.itemsHasErrored,
    isLoading: state.itemsIsLoading
  };
}
const mapDispatchToProps= (dispatch) => {
  return bindActionCreators({ selectMenuItem, ModalState, itemsFetchData}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PicadaRow);



/** WEBPACK FOOTER **
 ** ./src/containers/PicadaRow.js
 **/


/** WEBPACK FOOTER **
 ** ./src/containers/PicadaRow.js
 **/